import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { lazyWithRetry } from 'modules/Common/utils/lazyWithRetry';
import { UK_CALCULATOR_EMBED_PATH } from 'modules/Embed/useEmbedConfig';

// Lazy because _app.jsx imports this module at boot. A static import here pulled
// CostRadarPage -> QuotingMap -> chart.js, d3 and react-simple-maps into the
// entry graph for every visitor, and made the lazy CostRadarPage in _routes.jsx
// a no-op. It renders inside ContentWrapper's Suspense boundary.
const EmbedCostRadarPage = lazyWithRetry(() => import('modules/Embed/pages/EmbedCostRadarPage'));
const EmbedUkCalculatorPage = lazyWithRetry(
  () => import('modules/Embed/pages/EmbedUkCalculatorPage'),
);

// Routes for partner iframe embeds. Mounted by _app.jsx when the URL matches
// /embed/* — completely outside the SignedIn auth gate.
const EmbedRoutes = () => (
  <Switch>
    <Route
      path="/embed/cost-radar"
      exact
      component={EmbedCostRadarPage}
    />
    <Route
      path={UK_CALCULATOR_EMBED_PATH}
      exact
      component={EmbedUkCalculatorPage}
    />
  </Switch>
);

export default EmbedRoutes;
